module.exports = __webpack_public_path__ + "img/poultry-leg.b360df08.png";